"use client";

import React from "react";
import { Anchor, Radar, Crosshair, Cpu, Database, ShieldAlert } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const capabilitiesData = [{
  title: "Deep-Sea Tech",
  description: "Advanced submersible schematics and pressure-resistant hull designs engineered for abyssal exploration and covert operations beneath the ice shelves.",
  specs: [{
    label: "MAX DEPTH",
    value: "11,000M"
  }, {
    label: "HULL COMP",
    value: "TITANIUM-X"
  }, {
    label: "POWER",
    value: "FUSION CELL"
  }],
  icon: Anchor,
  delay: "0s"
}, {
  title: "Global Espionage",
  description: "Encrypted quantum communication networks and covert operative tracking systems deployed across worldwide shadow networks.",
  specs: [{
    label: "ENCRYPTION",
    value: "QUANTUM-256"
  }, {
    label: "NETWORK",
    value: "SAT-MESH"
  }, {
    label: "STATUS",
    value: "ACTIVE"
  }],
  icon: Radar,
  delay: "0.2s"
}, {
  title: "Tactical Intrigue",
  description: "Strategic asset deployment algorithms and high-stakes scenario modeling for unpredictable geopolitical threat environments.",
  specs: [{
    label: "THREAT LVL",
    value: "OMEGA"
  }, {
    label: "ASSETS",
    value: "DEPLOYED"
  }, {
    label: "PROBABILITY",
    value: "87.4%"
  }],
  icon: Crosshair,
  delay: "0.4s"
}];
export default function ProjectCapabilities() {
  return;
}